export const environment = {
  production: false,
  showDashboards: false,
  // Data Hub: the single consolidated data workspace (async reports, Pulse Check
  // / Impact event tables, license extensions). Replaces the old Data tab +
  // License Extensions page. Per-section visibility is data-driven from the
  // caller's group data_access (GET /agenthome/me). Flip to false as a kill-switch.
  showDataHub: true,
  // Abilities: the read-only catalog of every ability on the platform (search +
  // category browse, per-user access badges, request access). Runtime gate is
  // GET /agenthome/me → surfaces.abilities (config-repo flags.json); this is the
  // build-time fallback / local-dev default. Flip to false as a kill-switch.
  showAbilities: true,
  // Stats: the "time saved" widget (session count + minutes saved). Runtime
  // gate is GET /agenthome/me → surfaces.stats (config-repo flags.json); this
  // is the build-time fallback / local-dev default. Flip to false as a kill-switch.
  showStats: true,
  // Apps: the "Apps" rail tile in the hub. Clicking it opens the apps portal
  // (wg-agents-apps-ui) in a new tab with the session pre-loaded. Runtime gate
  // is GET /agenthome/me → surfaces.apps (config-repo flags.json); this is the
  // build-time fallback / local-dev default. Flip to false as a kill-switch.
  showApps: true,
  WG_AGENTS_BASE_URL: 'https://api.agents.dev-wg-agents.com/wgagents/',
  // Dedicated connectors API (wg-agents-connectors-api) — serves the per-user
  // OAuth Connections endpoints (GET/POST/DELETE /connections…) that used to
  // live on the hub API above.
  WG_CONNECTORS_BASE_URL: 'https://api.connectors.dev-wg-agents.com/connectors/',
  // WS URL for the unified AGENTHOME chat. Set by CI/CD from
  // SSM /dev/wg-agents-api/ws-url; set manually for local dev.
  WG_AGENTS_WS_URL: 'wss://f1fn1pfnxf.execute-api.us-west-2.amazonaws.com/dev',
  LOGIN_SSO_URL: 'https://api.agents.dev-wg-agents.com/wgagentslogin/ssologin',
  MSAL_CONFIG: {
    clientId: 'f529d809-fdd8-4726-9659-2fc6c6f8f51d',
    authority: 'https://login.microsoftonline.com/2563c132-88f5-466f-bbb2-e83153b3c808',
    redirectUri: 'https://agents.dev-wg-agents.com',
    postLogoutRedirectUri: 'https://agents.dev-wg-agents.com'
  },
  ADMIN_PORTAL_URL: 'https://admin.agents.dev-wg-agents.com',
  STUDIO_PORTAL_URL: 'https://studio.agents.dev-wg-agents.com',
  DEVTOOLS_PORTAL_URL: 'https://dev-tools.agents.dev-wg-agents.com',
  // Apps Portal (wg-agents-apps-ui). Flat subdomain — matches api.apps.* /
  // ws.apps.* backend hierarchy, not the sibling {name}.agents.* pattern.
  APPS_PORTAL_URL: 'https://apps.dev-wg-agents.com',
  HELP_PORTAL_URL: 'https://help.agents.dev-wg-agents.com',
  BASE_API: {
    STATIC: 'static',
    AUDIT_EVENT: 'audit/event',
    AUDIT_ACTIVITIES: 'audit/activities',
    FEEDBACK: 'agenthome/feedback',
  }
};
